import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getItem, localStorage } from 'common/storage';
import { LANG_CODES_KEYS, PREFERRED_LANGS } from 'common/constants';

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    debug: true,
    lng: getItem(localStorage, LANG_CODES_KEYS.i18nLang) || PREFERRED_LANGS[0].value,
    fallbackLng: PREFERRED_LANGS[0].value,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: { translation: require('./locales/en/translation.json') },
      fr: { translation: require('./locales/fr/translation.json') },
    }
  });

export default i18n;
